/**
 * @generated SignedSource<<b782a50f831f246f6022cfeefc7db386>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TimeSeriesChartAndTable_data$data = {
  readonly dimensions: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"TimeSeriesChart" | "TimeSeriesTable">;
  readonly " $fragmentType": "TimeSeriesChartAndTable_data";
};
export type TimeSeriesChartAndTable_data$key = {
  readonly " $data"?: TimeSeriesChartAndTable_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimeSeriesChartAndTable_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeSeriesChartAndTable_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimeSeriesChart"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimeSeriesTable"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TimeSeriesAnalyticsNodeDimension",
      "kind": "LinkedField",
      "name": "dimensions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TimeSeriesAnalyticsConnection",
  "abstractKey": null
};

(node as any).hash = "c51a4a31b290224345baa9bd0fe11039";

export default node;
